import { render, staticRenderFns } from "./CustomizationForm.vue?vue&type=template&id=cb263bfe&"
import script from "./CustomizationForm.vue?vue&type=script&lang=js&"
export * from "./CustomizationForm.vue?vue&type=script&lang=js&"
import style0 from "./CustomizationForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports